import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=703e68ec&scoped=true&"
import script from "./NotesList.vue?vue&type=script&lang=ts&"
export * from "./NotesList.vue?vue&type=script&lang=ts&"
import style0 from "./NotesList.vue?vue&type=style&index=0&id=703e68ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e68ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VBtnToggle,VCard,VChip,VFadeTransition,VLazy,VResponsive})
